import {
  ILoanDurationSelector,
  LoanDurationSelector,
} from '@axo/ui-form/components/LoanDurationSelector';
import { Controller, useFormContext } from 'react-hook-form';
import { useReloadValue } from '../../hooks';
import { IControlledField, IFormFields } from '../types';

interface Props<Fields> extends Pick<ILoanDurationSelector, 'country' | 'maxDuration' | 'minDuration' | 'loanAmountPerMonth' | 'recommended'>, IControlledField<Fields> { }

export const LoanDurationField = <Fields extends IFormFields>({
  name,
  rules,
  ...stepperProps
}: Props<Fields>) => {
  const { control } = useFormContext();
  useReloadValue(name);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value } }) => (
        <LoanDurationSelector
          {...stepperProps}
          onDurationChange={onChange}
          currentLoanDuration={value}
        />
      )}
    />
  );
};
